/*
Wire Pulls
  --length <float> | inches
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Wire'
const id = 'HWAg46TRB97CySUB08VR'

export default {
  name,
  id,
  filters,
  headers,
  form
}
